// extracted by mini-css-extract-plugin
export default {"filter-column-height":"SummaryFilterBox_filter-column-height__+r6YB","ipad-pro-filterbox":"SummaryFilterBox_ipad-pro-filterbox__BqPMn"};